import { buildProps, definePropType } from '@ll-plus/utils'
import { ExtractPropTypes } from 'vue'

import type { ProgressProps as AntProgressProps } from 'ant-design-vue'

import type ProgressBar from './progress-bar.vue'

export const progressBarProps = buildProps({
  hoverTip: {
    type: String,
    default: '',
  },
  format: {
    type: Function,
    default: (percent: number) => `${percent}%`,
  },
  // 文本方位
  textPosition: {
    type: String,
    values: ['left', 'center', 'right'],
    default: 'right',
  },
  success: {
    type: definePropType<AntProgressProps['success']>(Object),
    default: undefined,
  },
  strokeColor: {
    type: definePropType<AntProgressProps['strokeColor']>(Object),
    default: undefined,
  },
  steps: {
    type: Number,
    default: undefined,
  },
} as const)

export type ProgressBarProps = ExtractPropTypes<typeof progressBarProps>

export type ProgressBarInstance = InstanceType<typeof ProgressBar>
